export default "__VITE_ASSET__BtTF3Uri__"